module.exports = __webpack_public_path__ + "img/arrecredihome2v_1_b.bed8c1c9.webp";